import { Box, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import Text from "src/components/Displays/Text";
import { useNavigate } from "react-router-dom";
import { SMART_CHARGING_ROUTES } from "src/consts/Paths/SmartCharging";
import PrimaryButton from "src/components/Shared/PrimaryButton";

const Status = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSubmit = () => {
    navigate(SMART_CHARGING_ROUTES.TERMS);
  };

  return (
    <>
      <Stack gap={5}>
        <Text
          text={t("page.compatibilityStatus.pageTitle")}
          sx={(theme) => ({
            fontWeight: 500,
            fontSize: "32px",
            lineHeight: "40px",
            fontFamily: "officina",
          })}
        />

        <Text
          text={t("page.compatibilityStatus.pageSubTitle1")}
          sx={(theme) => ({
            fontSize: "14px",
            lineHeight: "24px",
            fontFamily: "Inter",
            color: theme.palette.mainFont.primary,
          })}
        />

        <Box>
          <PrimaryButton
            onClick={handleSubmit}
            text={t("page.compatibilityStatus.btnText")}
            sx={{ width: { xs: "100%", sm: "fit-content" } }}
          />
        </Box>
      </Stack>
    </>
  );
};

export default Status;
